module.exports = __webpack_public_path__ + "img/horizontal.b9c16dbd.png";